import { buildOrgUrl } from "@/utils/navigation/orgUrl";

type CustomerRow = { id: string; name: string };
type NavDeps = {
  router: { push: (location: string) => unknown };
  setCustomer?: (payload: CustomerRow) => unknown;
  clearAzureCache?: () => unknown;
  clearLicenceCache?: () => unknown;
};

export const redirectToCustomerDetails = (
  row: CustomerRow,
  { router, setCustomer, clearAzureCache, clearLicenceCache }: NavDeps,
) => {
  clearAzureCache?.();
  clearLicenceCache?.();
  setCustomer?.(row);
  return router.push(buildOrgUrl("customer", row.id, ""));
};
